var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MenuWest from "./menuWest";
import Drawers from "./drawers";
import MenuEast from "./menuEast";
import MenuNorth from "./menuNorth";
import Modal from "./modal";
export default function PageLayout() {
    var adminLayout = window.location.pathname.includes("InboundEmail") ||
        window.location.pathname.includes("OutboundEmailAccounts") ||
        window.location.pathname.includes("OAuthTokens") ||
        window.location.pathname.includes("OAuthKeys") ||
        window.location.pathname.includes("EmailMan") ||
        window.location.pathname.includes("ModuleBuilder") ||
        window.location.pathname.includes("modules/Administration") ||
        window.location.search.includes("page=admin");
    return (_jsxs("div", __assign({ className: "flex h-full flex-row flex-auto overflow-hidden" }, { children: [_jsx(MenuWest, {}), _jsxs("div", __assign({ className: "flex flex-col flex-auto overflow-hidden ".concat(adminLayout ? "bg-[var(--colors-widget)]" : "") }, { children: [_jsx(MenuNorth, {}), _jsx(Drawers, {})] })), _jsx(MenuEast, {}), _jsx(Modal, {})] })));
}
